import { lazy } from 'react';

// Lazy load public pages
export const HomePage = lazy(() => import('../pages/HomePage'));
export const FeaturesPage = lazy(() => import('../pages/FeaturesPage'));
export const PricingPage = lazy(() => import('../pages/PricingPage'));
export const AboutPage = lazy(() => import('../pages/AboutPage'));
export const ContactPage = lazy(() => import('../pages/ContactPage'));
export const BlogPage = lazy(() => import('../pages/BlogPage'));
export const IntegrationsPage = lazy(() => import('../pages/IntegrationsPage'));
export const DocumentationPage = lazy(() => import('../pages/DocumentationPage'));
export const CareersPage = lazy(() => import('../pages/CareersPage'));
export const ResourcesPage = lazy(() => import('../pages/ResourcesPage'));

// Lazy load auth pages
export const LoginPage = lazy(() => import('../pages/LoginPage'));
export const SignupPage = lazy(() => import('../pages/SignupPage'));

// Dashboard pages are now handled by TierRouter - no longer needed here
export const AIAssistantPage = lazy(() => import('../pages/client/AIAssistantPage'));
export const CampaignManagerPage = lazy(() => import('../pages/client/CampaignManagerPage'));
// export const ContentStudioV3 = lazy(() => import('../pages/client/ContentStudioV3')); // Temporarily disabled
export const WorkflowsPage = lazy(() => import('../pages/client/WorkflowsPage'));
export const ReportsPage = lazy(() => import('../pages/client/ReportsPage'));
export const AnalyticsPage = lazy(() => import('../pages/client/AnalyticsPage'));
export const SettingsPage = lazy(() => import('../pages/client/SettingsPage'));

// Lazy load content creation pages
export const BlogGeneratorPage = lazy(() => import('../pages/client/content/BlogGeneratorPage'));
export const SocialMediaPage = lazy(() => import('../pages/client/content/SocialMediaPage'));

// Lazy load enterprise pages
export const BrandVoiceManagerPage = lazy(() => import('../pages/client/BrandVoiceManagerPage'));
export const AdOpsHubPage = lazy(() => import('../pages/client/AdOpsHubPage'));
export const EnterpriseReportsPage = lazy(() => import('../pages/client/EnterpriseReportsPage'));
export const SecurityCompliancePage = lazy(() => import('../pages/client/SecurityCompliancePage'));

// Lazy load admin pages
export const AdminDashboardPro = lazy(() => import('../pages/admin/AdminDashboardPro'));
export const ClientPortalManagement = lazy(() => import('../pages/admin/ClientPortalManagement'));
export const ContentManagement = lazy(() => import('../pages/admin/ContentManagement'));
export const UserRolesPage = lazy(() => import('../pages/admin/UserRolesPage'));
export const SecurityCenter = lazy(() => import('../pages/admin/SecurityCenter'));

// Lazy load legal pages
export const PrivacyPage = lazy(() => import('../pages/PrivacyPage'));
export const TermsPage = lazy(() => import('../pages/TermsPage'));
export const SecurityPage = lazy(() => import('../pages/SecurityPage'));
export const CompliancePage = lazy(() => import('../pages/CompliancePage'));

// Loading component for Suspense fallback
export const PageLoader = () => (
  <div className="min-h-screen bg-black flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-500 mx-auto mb-4"></div>
      <p className="text-gray-400">Loading...</p>
    </div>
  </div>
);

// Error boundary for lazy loaded components
export const LazyErrorBoundary = ({ children }) => {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <div className="text-red-500 text-xl mb-4">⚠️</div>
        <p className="text-gray-400">Failed to load page. Please refresh and try again.</p>
      </div>
    </div>
  );
};
